const PERMISSION_KEY= "personalize:company_note";
const PAGE_URL = {
    COMPANY_NOTE_PAGE: "/admin/personalize/company-note"
}

export {PERMISSION_KEY, PAGE_URL}

